import { StepsInput } from "./components/StepsInput/StepsInput";
import { StepsTrackerChart } from "./components/StepsTrackerChart";
import { StepsTrackerProgressCard } from "./components/Progress/StepsTrackerProgressCard";
import { Tracker } from "../components/Trackers/Tracker";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { t } from "i18next";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import PageTitle from "UIPalette/PageTitle/PageTitle";

export const StepsTracker = () => {
  const { isMobileApp } = useMobilePlatform();

  return (
    <>
      <PageTitle title={t("pageTitle.wellbeing.stepTracker")} />
      <Tracker trackerType={TrackerType.Steps} heading={t("wellbeing.trackers.steps.title")}>
        <StepsTrackerProgressCard />
        <StepsTrackerChart />
        {!isMobileApp && <StepsInput />}
      </Tracker>
    </>
  );
};
